import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import FindHousingCounselorPage from "@/pages/tools/FindHousingCounselor";

export const Route = createFileRoute("/tools/find-housing-counselor")({
  head: () => seoHead("/tools/find-housing-counselor"),
  component: FindHousingCounselorPage,
});
